import { createTableSessionStore } from '@/components/admin/shared/hooks/table-session-store'

/** Session-storage slice for the system design table. */
export const sdTableStore = createTableSessionStore('bctci-sd-table')

/** Interface for persisted SD filter state */
export interface SDPersistedFilterState {
  globalFilter: string
  difficultyFilter: string | null
  sourceFilter: string | null
  topicsFilter: string[]
}

/** Default SD filter state */
export const DEFAULT_SD_FILTER_STATE: SDPersistedFilterState = {
  globalFilter: '',
  difficultyFilter: null,
  sourceFilter: null,
  topicsFilter: [],
}
